<template>
  <div class="error-container">
    <div class="error-page">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
      <a href="/plans" class="button">{{ $t("error.link") }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Error",
  created() {
    const { err } = this.$route.query;
    if (!err) {
      this.$router.push("/plans");
    } else {
      if (err == "403") {
        this.title = this.$t("error.403.header");
        this.description = this.$t("error.403.text");
      } else if (err == "404") {
        this.title = this.$t("error.404.header");
        this.description = this.$t("error.404.text");
      }
      this.$router.replace({ path: this.$route.path });
    }
  },
  data() {
    return {
      title: "Error",
      description: "An error has occurred",
    };
  },
};
</script>
<style scoped lang="scss">
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
</style>
